module.exports = __webpack_public_path__ + "static/img/pic1.c7cfc01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/pic1.png
// module id = h190
// module chunks = 1